@if (ngIfBloc) {
  <div class="form-bloc" [hidden]='hidden'>
    <div class="form_bloc-header">
      <div class="form_bloc-text">
        <h3 (click)="selectionnerTitrePrincipal()"
          [ngClass]="{'form_bloc-title': afficherTitrePrincipal,
                    'form_bloc-altertitle': alterTitreSelectionne(),
                    'form_bloc-cliquable': hasTitleSelection}">
          {{titre}}  @if (titreSpotLight) {
          <span class='form_bloc-title-spot-light'>{{titreSpotLight}}</span>
        }
        @if (subtitle) {
          <span class='form_bloc-title-subtitle'>{{subtitle}}</span>
        }
      </h3>
      @if (hasTitleSelection) {
        <h3
          (click)="selectionnerTitreAlternatif()"
          [ngClass]="{'form_bloc-title': alterTitreSelectionne(),
                    'form_bloc-altertitle': afficherTitrePrincipal,
                    'form_bloc-cliquable': true}">
          {{alterTitre}}
        </h3>
      }
    </div>
    @if (actions) {
      <div class="form_block-actions">
        <ng-template [ngTemplateOutlet]="actions"></ng-template>
      </div>
    }
    @if (buttonAddEnabled) {
      <ejs-tooltip [content]="buttonAddTitle" position="TopCenter">
        <button (click)="addClick()" class="form_bloc-button-add">
          <i class="icon icon-plus"></i>
        </button>
      </ejs-tooltip>
    }
    @if (buttonExportEnabled) {
      <button (click)="exportClick()" class="button-export">
        <i class="icon icon-microsoftexcel"></i> {{buttonExportTitle}}
      </button>
    }
    @if (buttonNavigateEnabled) {
      <div class="form_external_link" (click)="navigateClick()">
        <i class="icon icon-external-link"></i>
      </div>
    }
  </div>
  <div class="form_bloc-content" [ngClass]="{'-disabled': !haveContent}">
    <ng-content></ng-content>
  </div>
</div>
}
